import { Component, Inject, Input, ViewChild } from '@angular/core';
import { CalendarItemEnum } from 'src/app/models/enums/calendarItemType';
import { IconService } from '../../services/icon.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-social-networks-share-button',
  templateUrl: './social-networks-share-button.component.html',
  styleUrls: ['./social-networks-share-button.component.scss', './social-networks-share-button.component.en.scss'],
})
export class SocialNetworksShareButtonComponent {
  @Input({ required: true }) socialNetworksLinks: any[] = [];
  @Input({ required: true }) socialShareSettings!: any;
  @Input({ required: true }) eventUrl!: string;
  @Input() icon: string = '/Content/Images/icons/share.svg';
  CalendarItemEnum = CalendarItemEnum;

  @ViewChild('copyInput') copyInput?: any;
  copied: boolean = false;

  constructor(private iconService: IconService, @Inject(DOCUMENT) private document: Document) {
    this.iconService.addIconToRegistry({
      key: this.icon,
      path: this.icon,
    });
  }

  copyLinkByBtn(event: any) {
    event.stopPropagation();

    let input = this.copyInput.nativeElement;
    input.select();
    input.setSelectionRange(0, 99999);
    this.document.execCommand('copy');

    this.copied = true;
    setTimeout(() => {
        this.copied = false;
    }, 4000);
  }
}
